export default {
    computed: {
      displaySwitches() { return Object.entries((((this.$store.getters.settings.settings || {}).app || {}).show || {}).customer || {}).filter( e => e[1] ).map( e => e[0] ); },
    },
    methods: {
      show(blockName) { return this.displaySwitches.length===0 || this.displaySwitches.includes(blockName) },
    }
}